import { render, staticRenderFns } from "./nb-lock-warn.vue?vue&type=template&id=5d702a63&scoped=true"
import script from "./nb-lock-warn.vue?vue&type=script&lang=js"
export * from "./nb-lock-warn.vue?vue&type=script&lang=js"
import style0 from "./nb-lock-warn.vue?vue&type=style&index=0&id=5d702a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d702a63",
  null
  
)

export default component.exports